import React, { useState } from 'react';
import HeroManager from './content/HeroManager';
import ArticleManager from './content/ArticleManager';
import EventManager from './content/EventManager';
import PageContentManager from './content/PageContentManager';
import LookbookManager from './content/LookbookManager';
import MagazineManager from './content/MagazineManager';
import BrandSectionsManager from './content/BrandSectionsManager';
import PromotionalBannerManager from './content/PromotionalBannerManager';
import SeasonalBannerManager from './content/SeasonalBannerManager';
import CampaignManager from './content/CampaignManager';
import FooterManager from './content/FooterManager';

const AdminContent: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'hero' | 'promo' | 'seasonal' | 'campaigns' | 'brands' | 'articles' | 'events' | 'pages' | 'lookbook' | 'magazine' | 'footer'>('hero');

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tighter">Content Management</h1>
      </div>

      {/* Tabs */}
      <div className="flex gap-8 border-b border-gray-200 overflow-x-auto">
        {['hero', 'promo', 'seasonal', 'campaigns', 'brands', 'articles', 'events', 'pages', 'lookbook', 'magazine', 'footer'].map((tab) => (
            <button
                key={tab}
                onClick={() => setActiveTab(tab as any)}
                className={`pb-4 text-sm font-heading font-bold uppercase tracking-widest transition-colors whitespace-nowrap ${
                    activeTab === tab ? 'border-b-2 border-black text-black' : 'text-gray-400 hover:text-black'
                }`}
            >
                {tab === 'promo' ? 'Promo Banner' : tab === 'seasonal' ? 'Seasonal Banner' : tab === 'campaigns' ? 'Campaigns' : tab === 'lookbook' ? 'Lookbook' : tab === 'brands' ? 'Feature Section' : tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="min-h-[500px]">
        {activeTab === 'hero' && <HeroManager />}
        {activeTab === 'promo' && <PromotionalBannerManager />}
        {activeTab === 'seasonal' && <SeasonalBannerManager />}
        {activeTab === 'campaigns' && <CampaignManager />}
        {activeTab === 'brands' && <BrandSectionsManager />}
        {activeTab === 'articles' && <ArticleManager />}
        {activeTab === 'events' && <EventManager />}
        {activeTab === 'pages' && <PageContentManager />}
        {activeTab === 'lookbook' && <LookbookManager />}
        {activeTab === 'magazine' && <MagazineManager />}
        {activeTab === 'footer' && <FooterManager />}
      </div>
    </div>
  );
};

export default AdminContent;
